var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallFailed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.953,
    height: 19.953,
    viewBox: "0 0 19.953 19.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.089 -0.007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.548,19.96a3,3,0,0,1-.8-.11c-1.62-.45-4.42-1.854-8.555-5.99S.65,6.927.2,5.307A3.015,3.015,0,0,1,.97,2.372L3.189.153a.5.5,0,0,1,.707,0l4,4a.5.5,0,0,1,.062.631L6.186,7.443l6.42,6.42,2.659-1.772a.5.5,0,0,1,.631.062l4,4a.5.5,0,0,1,0,.707l-2.22,2.22A3.011,3.011,0,0,1,15.548,19.96ZM3.542,1.214,1.677,3.079a2.013,2.013,0,0,0-.514,1.96C1.581,6.544,2.915,9.173,6.9,13.153s6.611,5.316,8.115,5.734a2.015,2.015,0,0,0,1.958-.514l1.866-1.866L15.479,13.15,12.82,14.923a.5.5,0,0,1-.631-.063l-7-7a.5.5,0,0,1-.063-.631L6.9,4.57Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.207,4.5l2.647-2.646a.5.5,0,0,0-.708-.708L15.5,3.793,12.854,1.146a.5.5,0,0,0-.708.708L14.793,4.5,12.146,7.146a.5.5,0,0,0,.708.708L15.5,5.207l2.646,2.647a.5.5,0,0,0,.708-.708Z",
    transform: "translate(-0.089 -0.007)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallFailed);
export default __webpack_public_path__ + "static/media/Call_Failed.6973cfbb272c781698b2e58da549a4e4.svg";
export { ForwardRef as ReactComponent };